import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0d2750f7d6b5e2f93012988b5b90ef5f/25af5da9e7bb60657981414c6af3553e.jpeg" 
              alt="Clé Visa - Votre Partenaire Visa" 
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#accueil" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer">Accueil</a>
            <a href="#services" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer">Services</a>
            <a href="#avantages" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer">Avantages</a>
            <a href="#temoignages" className="text-gray-700 hover:text-teal-600 font-medium transition-colors whitespace-nowrap cursor-pointer">Témoignages</a>
            <a href="#contact" className="bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition-colors font-semibold whitespace-nowrap cursor-pointer">Contactez-nous</a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-teal-600 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#accueil" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">Accueil</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">Services</a>
              <a href="#avantages" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">Avantages</a>
              <a href="#temoignages" onClick={() => setIsMenuOpen(false)} className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer">Témoignages</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)} className="bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition-colors font-semibold text-center cursor-pointer">Contactez-nous</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
